import type { ChainData } from "@/constants/chain-details";
import Image from "next/image";
import type { FC } from "react";
import styles from "./chain-list-item.module.scss";

export const ChainListItem: FC<ChainData> = (chain) => {
  return (
    <>
      <Image src={chain.logo} alt="chain-logo" className={styles.chainLogo} />
      <div className={styles.chainDetails}>
        <p>{chain.chainName}</p>
        <span>{chain.ticker}</span>
      </div>
    </>
  );
};
